var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vf-pdf-text",class:[
    { 'vf-pdf-selected' : _vm.selected }
],domProps:{"innerHTML":_vm._s(_vm.cardData.header[_vm.$root.locale.key])},on:{"click":function($event){$event.stopPropagation();return _vm.handleClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }